module.exports = __webpack_public_path__ + "static/media/search.4bc2bd07.svg";